import { render, staticRenderFns } from "./answerSupportTicket.vue?vue&type=template&id=a4b7c8be&"
import script from "./answerSupportTicket.vue?vue&type=script&lang=js&"
export * from "./answerSupportTicket.vue?vue&type=script&lang=js&"
import style0 from "./answerSupportTicket.vue?vue&type=style&index=0&id=a4b7c8be&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports